import classNames from 'classnames'

import { RCTooltip } from 'components/RCTooltip'

import type { IVideoStatusDescriptionReturnProps } from './video-status-description.types'
import { ENTITY_UPDATE_STATUS } from '../common/posts.consts'
import { VideoIconStatus } from '../video-icon-status'
import './video-status-description.styles.scss'

export const VideoStatusDescriptionView = ({
  tooltipStatusMessage,
  textStatusPost,
  statusPost,
  postUrl,
}: IVideoStatusDescriptionReturnProps) => {
  if (!textStatusPost) {
    return null
  }

  return (
    <div
      className={classNames('VideoStatusDescription', {
        'VideoStatusDescription--has-status': statusPost,
        'VideoStatusDescription--success': statusPost === ENTITY_UPDATE_STATUS.SUCCESS,
      })}
    >
      <RCTooltip tooltipMessage={tooltipStatusMessage} direction="left" hideTooltip={!tooltipStatusMessage}>
        <span className="VideoStatusDescription__separator">•</span>
        <VideoIconStatus statusPost={statusPost} postUrl={postUrl} />
        <p className="VideoStatusDescription__text">{textStatusPost}</p>
      </RCTooltip>
    </div>
  )
}
